{
    "actions": {
        "page": {
            "add_customization": "Créer une personnalisation",
            "save": {
                "title": "Sauvegarder",
                "success": "Personnalisation sauvegardée avec succès",
                "error": "Échec de la sauvegarde de la personnalisation"
            },
            "publish": {
                "title": "Publier",
                "success": "Personnalisation publiée avec succès",
                "error": "Échec de la publication de la personnalisation"
            },
            "duplicate": "Dupliquer",
            "tooltip": {
                "error": {
                    "title": "Attention vérifiez les informations suivantes :",
                    "input_error": "Les champs de saisie obligatoires doivent être remplis",
                    "mode_automate_error": "En mode automate, un seul et unique bénéficiaire est autorisé"
                }
            }
        },
        "row": {
            "edit_label": "Renommer",
            "duplicate": "Dupliquer",
            "qr_code": "Afficher QR Code",
            "delete": "Supprimer"
        }
    },
    "keys": {
        "packageLabel": "Nom de la personnalisation",
        "packageCode": "Code d'initialisation",
        "status": "Statut",
        "posTerminalsNumbers": "Nombre de terminaux",
        "updatedAt": "Date de mise à jour",
        "color": "Code couleur",
        "logo": "Logo",
        "locale": "Langue",
        "createdAt": "Date de création"
    },
    "filter": {
        "placeholder": {
            "package_code": "Filtrer par code d'initialisation",
            "package_label": "Filtrer par nom",
            "locale": "Filtrer par langue",
            "color": "Filtrer par code couleur"
        }
    },
    "modal": {
        "update_label": {
            "title": "Modifier le libellé",
            "label": "Nom de la personnalisation",
            "placeholder": "Saisissez le nom de la personnalisation",
            "success": "Nom modifié avec succès",
            "error": "Échec de la modification du nom"
        },
        "delete": {
            "title": "Supprimer la personnalisation",
            "update_date": "Date de mise à jour",
            "status": "Statut",
            "confirm": "Êtes-vous sûr de vouloir supprimer la personnalisation {{packageLabel}} ?",
            "success": "Personnalisation supprimée avec succès",
            "error": "Échec de la suppression de la personnalisation"
        },
        "qr_code": {
            "title": "QR Code",
            "description": "Ce QR Code peut être utilisé pour télécharger votre personnalisation sur votre TPE",
            "download": "Téléchargez ici",
            "pdf": {
                "title": "Preludd Payment Services",
                "subtitle": "Découvrez Payludd : votre solution de paiement hybride sur terminaux Autonomes",
                "information": "Informations",
                "merchant_account": "Compte marchand:",
                "initialization_code": "Code d'initialisation:",
                "customization_name": "Nom de la personnalisation:",
                "color_code": "Code couleur:",
                "selected_language": "Langue sélectionnée:"
            }
        },
        "add_beneficiaries": {
            "title": "Bénéficiaire",
            "text": "Associez les bénéficiaires de votre marchand",
            "error": "Une erreur est survenue lors de la récupération des bénéficiaires."
        }
    },
    "status": {
        "NEW": "Nouveau",
        "PUBLISHED": "Publié",
        "DRAFT": "Brouillon"
    },
    "details": {
        "fields": {
            "init_code": {
                "label": "Code initialisation",
                "tooltip": "Le code d'initialisation est généré lors de la publication de la personnalisation"
            },
            "name": {
                "label": "Nom personnalisation"
            },
            "locale": {
                "label": "Choix langue"
            },
            "color": {
                "label": "Code couleur"
            },
            "logo": {
                "label": "Logo",
                "text1": "• 200 Ko max",
                "text2": "• Format: jpeg, jpg, png",
                "error": "Le fichier sélectionné est trop volumineux"
            }
        },
        "functionnalities": {
            "payment_triggers": {
                "title": "Mode de déclenchement des paiements",
                "keys": {
                    "port": "Port :",
                    "exchange_speed_hover": "Vitesse d'échange en série (RS232)",
                    "exchange_speed": "Vitesse série"
                },
                "options": {
                    "amountScreenDisplay": {
                        "title": "Saisie manuelle du montant"
                    },
                    "donationMode": {
                        "title": "Dons"
                    },
                    "automateMode": {
                        "title": "Automate",
                        "warning": "Un seul bénéficiaire autorisé pour un automate"
                    },
                    "externalTrigger": {
                        "title": "Caisse",
                        "warning": "Lorsqu'un mode caisse est sélectionné, la sécurisation du burger menu est recommandée",
                        "error": "Veuillez sélectionner au moins un mode de caisse",
                        "all_cashier_options": "toutes les options",
                        "appToAppMode": "AppToApp",
                        "concertProtocolV320": "Wifi/Ethernet",
                        "concertProtocolV2Usb": "USB V2",
                        "concertProtocolV2": "RS232 V2",
                        "hover":{
                            "concertProtocolV320": "Wifi/ Ethernet (Concert V2 et V3.X)",
                            "concertProtocolV2Usb": "USB (Concert V2)",
                            "concertProtocolV2": "RS232 (Concert V2)"
                        }
                    }
                },
                "errors": {
                    "port_input": "Veuillez saisir un numéro de port valide (1024-65535)"
                }
            },
            "lock": {
                "title": "Blocage services et applications",
                "warning": "Lorsqu'un mode caisse est sélectionné, la sécurisation du burger menu est recommandée",
                "kioskMode": "[Prochainement] Blocage de l'application FRV6 (mode Kiosk)",
                "burgerMenuLock": {
                    "text": "Protection du menu par mot de passe",
                    "tooltip": "Pour accéder au menu un mot de passe est demandé. Il s'agit des 4 avant-derniers chiffres du numéro de série du terminal. Attention : sans le mot de passe il sera impossible d'accéder à l'historique des transactions et de réimprimer des tickets."
                }
            },
            "payment_tickets": {
                "title": "Gestion des tickets de paiement",
                "merchant": {
                    "title": "Ticket commerçant",
                    "nativeMerchantReceipt": "Affichage et impression du ticket commerçant natif"
                },
                "client": {
                    "title": "Ticket client",
                    "option_1": "Affichage et impression du ticket client natif",
                    "option_2": "Dématérialisation du ticket client (QR code)"
                }
            },
            "additional_services": {
                "title": "Services additionnels",
                "option_1": "Pourboire",
                "option_2": "Saisie du code employé",
                "option_3": "Saisie d'une référence commande"
            }
        },
        "monetic_settings": {
            "gateway": {
                "title": "Passerelles",
                "main_address": "Adresse principale",
                "forcing_gateway": "Forcer la passerelle",
                "tooltip": "Tous les contrats présents sur le terminal utiliseront cette passerelle",
                "address": "Adresse IP : ",
                "port": "Port : ",
                "backup": "Secours",
                "none": "Aucune"
            },
            "beneficiaries": {
                "title": "Bénéficiaire",
                "add": "Associer"
            }
        }
    }
}